import React, { useEffect } from 'react';
import { Loader } from 'components/Base';
import StoreProvider from 'store/store';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';

const { connect, actions, selectors } = StoreProvider;

const withMeta = (WrappedComponent: any) => {
  const ComponentWithMeta = ({
    isMetaLoaded,
    getMetaData,
    isLoadingMeta,
    ...props
  }: any) => {
    const { isAuthenticated, loading } = useAuth();

    useEffect(() => {
      if (!isMetaLoaded && !isLoadingMeta && isAuthenticated) {
        getMetaData();
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMetaLoaded, isAuthenticated]);
    return (
      <Loader isLoading={!isMetaLoaded && loading}>
        <WrappedComponent {...props} />
      </Loader>
    );
  };

  return connect(
    state => ({
      isMetaLoaded: selectors.metaSelectors.isMetaLoaded(state),
      isLoadingMeta: selectors.metaSelectors.isLoadingMeta(state)
    }),
    {
      getMetaData: actions.metaActions.getMetaData
    }
  )(ComponentWithMeta);
};

export default withMeta;
